import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function ResourcesNewsletter() {
  return <section className="w-full bg-brand-light-gray py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-158" data-mp="jcywp860gldp">
      <div className="max-w-4xl mx-auto" data-id="element-159" data-mp="ee5i1cezmoby">
        <div className="bg-white p-10 md:p-16 rounded-lg shadow-sm border-t-4 border-brand-orange" data-id="element-160" data-mp="ecuar2mc2yg3">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-8" data-id="element-161" data-mp="9esrohowqz4m">
            Broken Pencils
          </h2>
          <p className="text-xl text-brand-gray leading-relaxed mb-12" data-id="element-162" data-mp="5ftsldpuxwl3">
            A newsletter about AI transformation, leadership, and the
            messy reality of getting teams to work differently. Published every
            other week. Read by leaders figuring out what AI means for how
            their teams work.
          </p>

          <div className="bg-brand-light-gray p-8 rounded-lg mb-10 border border-gray-100 shadow-sm" data-id="element-163" data-mp="3hvnopgj0xpas">
            <iframe src="https://embeds.beehiiv.com/792bb15f-3a0a-4874-bffc-3a18450d8d36?slim=true" data-test-id="beehiiv-embed" height="52" frameBorder="0" scrolling="no" style={{
            margin: 0,
            borderRadius: '0px',
            backgroundColor: 'transparent',
            width: '100%'
          }} data-id="element-164" data-mp="3dtafuj8zdb9s"></iframe>
          </div>

          <a href="https://newsletter.breakapencil.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center font-bold text-brand-orange hover:text-brand-orange-hover transition-colors text-lg" data-id="element-165" data-mp="3exeft0aep6kz">
            Read past issues
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-166" data-mp="1kuks2jx57km" />
          </a>
        </div>
      </div>
    </section>;
}